import React from 'react';
import {
    TableHeader,
    TableHeaderContainer,
} from './index.styled.jsx';
import {
    FONT_FAMILY_DEMI,
    X_SMALL_TEXT_PX,
    SMALL_TEXT_PX,
    DARK_NAVY_FONT_COLOR,
} from 'src/styles/fonts/MCFontConstants';
import { useTranslation } from 'react-i18next';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import {
    getCurrencySymbol,
} from 'src/utils/util';

const TableHeaderData = ({
    isForProductGuide,
    isSurgery,
    isTablet,
    countryISOCode,
    isAddToBundle,
    isIPadPro,
    isEquityPage,
    isSubItem,
    isForSetItem,
    isQuickOrder,
    isShippingScreen,
    isReviewSubmitScreen,
    isReviewSubmitScreenEquity,
    isOrderScreen,
    isBundleView,
    isTemplateScreen,
    isEquityTemplate,
    isTemplateDetail,
    isItemListView,
    orderType,
    isFromTemplates,
    isCondensedView,
    showDontShip,
    isItem,
    shipDontShipSurgery,
    checkAll,
    handleShipAllChange,
    isImplant,
    checkSelectAllDisabled,
    products,
    selectAllDisabled,
    ipadMini,
    isTissueProduct,
    currencyISOCode,
    isFromIndependentProductGuide,
    isItemBundlePopup
}) => {
    const { t } = useTranslation();
    return(
        <TableHeaderContainer
                    position={isForProductGuide && 'sticky'}
                    top={isForProductGuide && '0'}
                    zIndex={isForProductGuide && '1'}
                    height={isForProductGuide && '50px'}
                >
                    <tr>
                        <TableHeader
                        ipadPadding={'0px'}
                        ipadAirPadding={'0px'}
                            width={
                                isSurgery && isTablet
                                    ? countryISOCode === 'US'
                                        ? '17%'
                                        : '25%'
                                    : countryISOCode === 'US'
                                    ? isAddToBundle && isIPadPro
                                        ? '25%'
                                        : '17%'
                                    : isSurgery
                                    ? '18%'
                                    : isEquityPage && isTablet
                                    ? '12%'
                                    : '25%'
                            }
                            isSubItem={isSubItem}
                            paddingLeft={true}
                            ipadPaddingLeft = {isQuickOrder && '5px'}
                            ipadAirPaddingLeft = {isQuickOrder && '5px'}
                            fontSize={isForProductGuide && SMALL_TEXT_PX }
                        >
                            {t(
                                'scheduleSurgery.surgery.notifications.itemListView.Product'
                            )}
                        </TableHeader>
                        {countryISOCode === 'US' &&
                            !isForProductGuide &&
                            !isForSetItem && (
                                <TableHeader
                                    width={isSubItem ? '6.5%' : '8%'}
                                    isSubItem={isSubItem}
                                    paddingLeft={true}
                                ></TableHeader>
                            )}
                        <TableHeader
                        isForSetItem = {isForSetItem}
                            isForProductGuide = {isForProductGuide}
                            isQuickOrder = {isQuickOrder}
                            isSubItem={isSubItem}
                            width={
                                isSurgery && isTablet
                                    ? '30%'
                                    : isSurgery
                                    ? '35%'
                                    : isShippingScreen
                                    ? '28%'
                                    : isReviewSubmitScreen
                                    ? '50%'
                                    : isReviewSubmitScreenEquity
                                    ? '30%'
                                    : isOrderScreen
                                    ? '35%'
                                    : isEquityPage
                                    ? isSubItem
                                        ? '31.5%'
                                        : '20%'
                                    : isBundleView && isTemplateScreen
                                    ? '36%'
                                    : isSubItem && isEquityTemplate
                                    ? '24%'
                                    : isSubItem && isTemplateDetail
                                    ? '25.5%'
                                    : '36%'
                            }
                            fontSize={isForProductGuide && SMALL_TEXT_PX }
                        
                            ipadAirPaddingLeft={'10px !important'}
                        >
                            {t(
                                'scheduleSurgery.surgery.notifications.itemListView.description'
                            )}
                        </TableHeader>
                        {(isReviewSubmitScreen ||
                            isReviewSubmitScreenEquity ||
                            isTemplateScreen ||
                            isOrderScreen) &&
                            !isBundleView && (
                                <TableHeader
                                    width="12%"
                                    className="brand"
                                    isSubItem={isSubItem}
                                >
                                    {t(
                                        'scheduleSurgery.surgery.notifications.itemListView.brand'
                                    )}
                                </TableHeader>
                            )}
                        {(isOrderScreen ||
                            isReviewSubmitScreenEquity ||
                            isTemplateScreen) &&
                            isBundleView && (
                                <TableHeader
                                    width={
                                        isReviewSubmitScreenEquity
                                            ? '15%'
                                            : isBundleView
                                            ? '16%'
                                            : '16%'
                                    }
                                    className="brand"
                                    isSubItem={isSubItem}
                                >
                                    {t(
                                        'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.inBundle'
                                    )}
                                </TableHeader>
                            )}
                        {isOrderScreen &&
                            !isSubItem &&
                            !isItemListView &&
                            orderType !== 'KE' &&
                            orderType !== 'KB' && (
                                <TableHeader
                                    width={isOrderScreen ? '15%' : '16%'}
                                    className="brand"
                                    isSubItem={isSubItem}
                                >
                                    {t('common.tableView.statusLabel')}
                                </TableHeader>
                            )}
                        {(isTemplateScreen || isOrderScreen) && (
                            <>
                                <TableHeader
                                    width={
                                        isReviewSubmitScreenEquity
                                            ? '12%'
                                            : '15%'
                                    }
                                    className="quantityUoM"
                                    isSubItem={isSubItem}
                                >
                                    {t('common.tableView.qtyUom')}
                                </TableHeader>
                                {!isOrderScreen && !isFromTemplates && (
                                    <TableHeader
                                        className="quantity"
                                        isSubItem={isSubItem}
                                        width={
                                            isAddToBundle &&
                                            isIPadPro &&
                                            isCondensedView
                                                ? '3%'
                                                : '10%'
                                        }
                                    ></TableHeader>
                                )}
                            </>
                        )}

                        {isShippingScreen ||
                        isReviewSubmitScreen ||
                        isReviewSubmitScreenEquity ? (
                            <>
                                <TableHeader
                                    width={
                                        isShippingScreen
                                            ? '15%'
                                            : isReviewSubmitScreenEquity
                                            ? '16%'
                                            : '16%'
                                    }
                                    className="quantityUoM"
                                    isSubItem={isSubItem}
                                >
                                    {t('common.tableView.quantityUom')}
                                </TableHeader>
                                {!isReviewSubmitScreen &&
                                    !isReviewSubmitScreenEquity &&
                                    showDontShip && (
                                        <TableHeader
                                            width={isShippingScreen && '15%'}
                                            className="quantity"
                                            isSubItem={isSubItem}
                                            padding={isShippingScreen && '7px 8px'}
                                        >
                                            {!isItem &&
                                                shipDontShipSurgery !==
                                                    'NOT_VISIBLE' && (
                                                    <Checkbox
                                                        checked={checkAll}
                                                        label={t(
                                                            'common.dontShip'
                                                        )}
                                                        onCheckboxSelectionChange={() => 
                                                            handleShipAllChange(
                                                                isImplant
                                                                    ? 'implant'
                                                                    : 'instrument'
                                                            )
                                                        }
                                                        disabled={
                                                            checkSelectAllDisabled(
                                                                products,
                                                                countryISOCode
                                                            ) ||
                                                            selectAllDisabled
                                                        }
                                                        id = 'dont-ship-all-checkbox'
                                                        margin={'0 6px 0 0'}
                                                        labelStyleObj={{
                                                            fontSize: X_SMALL_TEXT_PX,
                                                            fontFamily: FONT_FAMILY_DEMI,
                                                            color: DARK_NAVY_FONT_COLOR,
                                                            margin: '0px 0px 0px 3px',
                                                            fontWeight: '700'
                                                        }}
                                                        background={'none'}
                                                        checkboxBorder={'1.5px solid #555555'}
                                                        alignItemDirection={'center'}
                                                        hoverEffect={'false'}
                                                        disableFocusEffect={'true'}
                                                    />
                                                )}
                                        </TableHeader>
                                    )}
                                {!isReviewSubmitScreen &&
                                    !isReviewSubmitScreenEquity && (
                                        <TableHeader
                                            width={
                                                isShippingScreen
                                                    ? ipadMini
                                                        ? '20%'
                                                        : '28%'
                                                    : '18%'
                                            }
                                            className="batch"
                                            isSubItem={isSubItem}
                                        >
                                            {!isItem &&
                                                !isTissueProduct &&
                                                (shipDontShipSurgery !==
                                                    'NOT_VISIBLE' ||
                                                    products
                                                        ?.filter(
                                                            (item) =>
                                                                !item?.isTemplateEntryDeleted
                                                        )
                                                        .some(
                                                            (item) =>
                                                                item.isSet &&
                                                                item.isReservationSet
                                                        )) &&
                                                t('common.batchSelection')}
                                        </TableHeader>
                                    )}

                                {isReviewSubmitScreenEquity && !isSubItem && !isItemBundlePopup && (
                                    <>
                                        {' '}
                                        <TableHeader
                                            className="uom"
                                            width={
                                                isReviewSubmitScreenEquity
                                                    ? '12%'
                                                    : '14%'
                                            }
                                            isSubItem={isSubItem}
                                        >
                                            {`${t(
                                                'common.tableView.unitPrice'
                                            )} ${getCurrencySymbol(
                                                currencyISOCode
                                            )}`}
                                        </TableHeader>
                                        <TableHeader
                                            className="uom"
                                            width={
                                                isReviewSubmitScreenEquity
                                                    ? '12%'
                                                    : '14%'
                                            }
                                            isSubItem={isSubItem}
                                        >
                                            {`${t(
                                                'common.tableView.extPrice'
                                            )} ${getCurrencySymbol(
                                                currencyISOCode
                                            )}`}
                                        </TableHeader>
                                    </>
                                )}
                            </>
                        ) : (
                            !isTemplateScreen &&
                            !isOrderScreen && (
                                <>
                                    {!isBundleView && (
                                        <TableHeader
                                            width={isEquityPage ? '12%' : '16%'}
                                            className="brand"
                                            isSubItem={isSubItem}
                                            fontSize={
                                                isForProductGuide && SMALL_TEXT_PX
                                            }
                                        >
                                            {t(
                                                'scheduleSurgery.surgery.notifications.itemListView.brand'
                                            )}
                                        </TableHeader>
                                    )}
                                    {isBundleView && (
                                        <TableHeader
                                            width={
                                                isEquityTemplate ? '20%' : '16%'
                                            }
                                            className="brand"
                                            isSubItem={isSubItem}
                                        >
                                            {t(
                                                'orders.orderDetails.orderDetailTab.extrasOrderDetail.Bundle.inBundle'
                                            )}
                                        </TableHeader>
                                    )}
                                    {!isForProductGuide && !isForSetItem && (
                                        <TableHeader
                                            className="quantity"
                                            isSubItem={isSubItem}
                                            width={
                                                isEquityPage
                                                    ? '13%'
                                                    : isBundleView &&
                                                      !isEquityTemplate
                                                    ? '10%'
                                                    : isSurgery &&
                                                      countryISOCode === 'US'
                                                    ? '13%'
                                                    : '11%'
                                            }
                                        >
                                            {t('common.tableView.quantity')}
                                        </TableHeader>
                                    )}
                                    {!isReviewSubmitScreen &&
                                        !isForSetItem &&
                                        !isFromIndependentProductGuide && (
                                            <TableHeader
                                                className="uom-wrapper"
                                                isSubItem={isSubItem}
                                                width={
                                                    isEquityPage
                                                        ? isSubItem
                                                            ? '6%'
                                                            : '13%'
                                                        : isItemBundlePopup
                                                        ? '11%'
                                                        : isForProductGuide
                                                        ? '14%'
                                                        : '7%'
                                                }
                                                textAlign={
                                                    isForProductGuide && 'left'
                                                }
                                                fontSize={
                                                    isForProductGuide && '14px'
                                                }
                                                padding={
                                                    isForProductGuide &&
                                                    '7px 23px'
                                                }
                                            >
                                                <div>
                                                    {t('common.tableView.uom')}
                                                </div>
                                            </TableHeader>
                                        )}
                                    {isEquityPage && !isSubItem && !isItemBundlePopup && (
                                        <TableHeader
                                            className="uom"
                                            isSubItem={isSubItem}
                                            width={
                                                isTablet
                                                    ? isEquityPage && '11%'
                                                    : isEquityPage && '9%'
                                            }
                                        >
                                            {`${t(
                                                'common.tableView.unitPrice'
                                            )} ${getCurrencySymbol(
                                                currencyISOCode
                                            )}`}
                                        </TableHeader>
                                    )}
                                    {isEquityPage && !isSubItem && !isItemBundlePopup && (
                                        <TableHeader
                                            className="extPrice"
                                            isSubItem={isSubItem}
                                            width={
                                                isTablet
                                                    ? isEquityPage && '11%'
                                                    : isEquityPage && '11%'
                                            }
                                        >
                                            {`${t(
                                                'common.tableView.extPrice'
                                            )} ${getCurrencySymbol(
                                                currencyISOCode
                                            )}`}
                                        </TableHeader>
                                    )}
                                    {!isForProductGuide && !isForSetItem && (
                                        <TableHeader
                                            className="quantity"
                                            isSubItem={isSubItem}
                                            width={
                                                isSubItem && !isEquityTemplate
                                                    ? '5%'
                                                    : isSubItem &&
                                                      isEquityTemplate
                                                    ? '10%'
                                                    : isBundleView &&
                                                      !isEquityTemplate
                                                    ? '5%'
                                                    : isEquityPage
                                                    ? '5%'
                                                    : '10%'
                                            }
                                        ></TableHeader>
                                    )}
                                </>
                            )
                        )}
                        {isForSetItem && (
                            <>
                                <TableHeader
                                    width={
                                        isShippingScreen
                                            ? '15%'
                                            : isReviewSubmitScreenEquity
                                            ? '16%'
                                            : '16%'
                                    }
                                    className="quantityUoM"
                                    isSubItem={isSubItem}
                                >
                                    {t('common.tableView.quantityUom')}
                                </TableHeader>
                                <TableHeader width="7%"></TableHeader>
                            </>
                        )}
                    </tr>
                </TableHeaderContainer>
    );
};

export default TableHeaderData;
